// src\themes\lino\elements\comment\CommnetItem.tsx
import React from 'react';

import { CommentItem as CommentType } from '@/core/types/comments';

interface CommentItemProps {
  comment: CommentType;
}

export default function CommentItem({ comment }: CommentItemProps) {
  return (
    <li className="border-b border-primary-100 pb-5 last:border-0">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[13px] text-primary-900 font-medium tracking-wide">
          {comment.author_name}
        </div>
        <div className="text-[11px] text-primary-400">
          {comment.created_at_jalali ??
            new Date(comment.created_at).toLocaleString()}
        </div>
      </div>
      {comment.subject ? (
        <div className="text-[13px] text-primary-700 mb-1.5">{comment.subject}</div>
      ) : null}
      <p className="text-[13px] text-primary-600 leading-7">{comment.content}</p>
    </li>
  );
}